import { render, staticRenderFns } from "./CommentManagement.vue?vue&type=template&id=ac5aa884&scoped=true"
import script from "./CommentManagement.vue?vue&type=script&lang=js"
export * from "./CommentManagement.vue?vue&type=script&lang=js"
import style0 from "./CommentManagement.vue?vue&type=style&index=0&id=ac5aa884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5aa884",
  null
  
)

export default component.exports